<template>
    <v-content
        class="ma-0 pa-0"
    >
        <v-row
            justify="center"
            no-gutters
        >
            <v-col
                cols="12"
            >
                <SignIn
                    v-if="currentAuthView == 'SignIn'"
                />
                <SignUp
                    v-if="currentAuthView == 'SignUp'"
                />
                <ForgotPassword
                    v-if="currentAuthView == 'ForgotPassword'"
                />
                <ChangePassword
                    v-if="currentAuthView == 'ChangePassword'"
                />
            </v-col>
        </v-row>
        <!-- <v-row
            class="mt-10"
        >
            <div class="auth">
                <amplify-authenticator></amplify-authenticator>
            </div>
        </v-row> -->
    </v-content>
</template>

<script>
    import { Auth } from 'aws-amplify'
    import SignIn from '@/components/login/SignIn.vue'
    import SignUp from '@/components/login/SignUp.vue'
    import ForgotPassword from '@/components/login/ForgotPassword.vue'
    import ChangePassword from '@/components/login/ChangePassword.vue'

    export default {
        data: () => ({
            show: false,
            username: null,
            password: null,
            errorMessage: null,
        }),

        components: {
            SignIn,
            SignUp,
            ForgotPassword,
            ChangePassword,
        },

        methods: {
            signIn: function() {
                this.errorMessage = null;

                Auth.signIn({
                    username: this.username,
                    password: this.password
                }).then(user => console.log(user))
                .catch(error => this.processError(error));  
            },
            
            processError: function(error) {
                console.log(error);
                this.errorMessage = error.message;
            }
        },

        computed: {
            currentAuthView() {
                return this.$store.getters['login/currentAuthView'];
            }
        }

    }
</script>

<style>
.auth {
  margin: 0 auto;
  width: 460px;
}
</style>